import React from 'react';
import { candidacyRatingCreateMutation } from '../graphql/mutations/CandidacyRatingCreateMutation';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/CandidacyRating.json';
import inputTypeIntro from '../static/introspection/CandidacyRatingCreateInput.json';
import { toRefInput } from '../utils/dataTrasform';
import { ENTITY } from '../utils/entities';
import { fastTransformer, toHidden } from '../utils/form';
import { EntityCreateModal } from '../types/entities';
import { Candidacy, CandidacyRating } from '../server-types';
import { transformerHandler } from '../utils/misc';

export const CandidacyRatingCreate: React.FC<EntityCreateModal<
	CandidacyRating,
	Candidacy
>> = ({ id, onSubmit, originalEntity }) => (
	<EntityEditFetcher
		id={id}
		onSubmit={onSubmit}
		create={true}
		modal={true}
		mutation={candidacyRatingCreateMutation}
		typeIntro={typeIntro}
		inputTypeIntro={inputTypeIntro}
		entityName={ENTITY.CANDIDACY_RATING}
		fields={[
			'User',
			'Candidacy',
			'overall',
			'rating1',
			'rating2',
			'rating3',
			'rating4',
			'rating5',
			'comment1',
			'comment2',
			'comment3',
			'askSample',
		
		]}
		transformer={transformerHandler(
			fastTransformer({
				Candidacy: toHidden(toRefInput(originalEntity)),
			}),
		)}
	/>
);
